import { render, staticRenderFns } from "./SubjectButton.vue?vue&type=template&id=0ba054fe&scoped=true&"
import script from "./SubjectButton.vue?vue&type=script&lang=ts&"
export * from "./SubjectButton.vue?vue&type=script&lang=ts&"
import style0 from "./SubjectButton.vue?vue&type=style&index=0&id=0ba054fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba054fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
